import classNames from 'classnames'
import * as React from 'react'

import {RefProp} from '../types'

export const orientation = ['vertical', 'horizontal'] as const

export interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  orientation?: (typeof orientation)[number]
  blocked?: boolean
}

const Card: React.FC<RefProp<HTMLAnchorElement, Props>> = ({
  elementRef,
  className,
  orientation,
  children,
  blocked,
  ...rest
}) => {
  const classes = ['card', className]

  if (blocked) {
    classes.push('card__blocked')
  }

  if (orientation) {
    classes.push('card--' + orientation)
  }

  return (
    <a ref={elementRef} className={classNames(...classes)} {...rest}>
      {children}
    </a>
  )
}

export default React.forwardRef<HTMLAnchorElement, Props>((props, ref) => (
  <Card elementRef={ref} {...props} />
))
